import { Component, DestroyRef, ViewChild } from '@angular/core';
import { AddOrganizationForm } from "../../../../forms/add-organization/add-organization.form";
import { BootstrapService } from '../../../../core/services/bootstrap.service';
import { ModalActions, ModalTypes } from '../../../../core/enums/base.enums';
import { InfoModalComponent } from '../../../../parts/info-modal/info-modal.component';
import { ConfirmationModalComponent } from "../../../../parts/confirmation-modal/confirmation-modal.component";
import { ServiceResultModel } from '../../../../core/models/service/service-result.model';
import { GenericMessagingConstants } from '../../../../core/constants/messaging.constants';
import { EscCloseDirective } from '../../../../core/directives/esc-close.directive';
import { BaseFormComponent } from '../../../../core/base-classes/base-form-component';
import { CanComponentDeactivate } from '../../../../core/routing/can-deactivate.guard';
import { DirtyFormRegistryService } from '../../../../core/services/dirty-form-registry.service';

@Component({
  selector: 'ms-add-organization',
  imports: [AddOrganizationForm, InfoModalComponent, ConfirmationModalComponent, EscCloseDirective],
  templateUrl: './add-organization.component.html',
})
export class AddOrganizationComponent extends BaseFormComponent implements CanComponentDeactivate {
  private resetFormOnConfirm : boolean = true;

  @ViewChild(AddOrganizationForm) addOrganizationFormRef!: AddOrganizationForm;
  @ViewChild('organizationFormInfoModalRef') organizationFormInfoModalRef!: InfoModalComponent;
  @ViewChild('organizationFormConfirmationModalRef') organizationFormConfirmationModalRef!: ConfirmationModalComponent;

  constructor(
    private bootstrapService: BootstrapService,
    private dirtyFormRegistry: DirtyFormRegistryService,
    private destroyRef: DestroyRef
  ) {
    super();
    this.destroyRef.onDestroy(() => this.dirtyFormRegistry.unregister(this));
  }

   public onCancel(): void {
    if (this.addOrganizationFormRef.addOrganizationForm.dirty) {
      this.organizationFormConfirmationModalRef.modalType.set(ModalTypes.Question);

      this.organizationFormConfirmationModalRef.message.set(GenericMessagingConstants.GENERIC_ABORT_CONFIRMATION());

      this.bootstrapService.manageModal("#organizationFormConfirmationModal", ModalActions.Show);
      this.bootstrapService.manageModal("#addOrganizationModal", ModalActions.Hide);
    } else {
      this.bootstrapService.manageModal("#addOrganizationModal", ModalActions.Hide);
      this.dirtyFormRegistry.unregister(this);
    }
  }

  public canDeactivate(): boolean | Promise<boolean> {
    return this.awaitLeaveConfirmation(this.addOrganizationFormRef.addOrganizationForm.dirty && !this.submitSucceeded, () => {
      this.organizationFormConfirmationModalRef.modalType.set(ModalTypes.Question);
      this.organizationFormConfirmationModalRef.message.set(GenericMessagingConstants.GENERIC_ABORT_CONFIRMATION());
      this.bootstrapService.manageModal("#addOrganizationModal", ModalActions.Hide);
      this.bootstrapService.manageModal("#organizationFormConfirmationModal", ModalActions.Show);
    });
  }

  public openAddOrganizationModal(): void {
    this.submitSucceeded = false;
    this.dirtyFormRegistry.register(this);
    this.bootstrapService.manageModal("#addOrganizationModal", ModalActions.Show);
  }

  public confirmationModalConfirmed(): void {
    this.addOrganizationFormRef.resetForm();
    this.bootstrapService.manageModal("#organizationFormConfirmationModal", ModalActions.Hide);
    this.dirtyFormRegistry.unregister(this);
    this.resolvePendingLeave(true);
  }

  public infoModalConfirmed(): void {
    if (this.resetFormOnConfirm === true) {
      this.submitSucceeded = false;
      this.addOrganizationFormRef.resetForm();
      this.dirtyFormRegistry.unregister(this);
    }
  }

  public onAddOrganizationResult(result: ServiceResultModel): void {
    this.resetFormOnConfirm = result.success!;

    this.organizationFormInfoModalRef.message.set(result.message);

    if (result.success === true) {
      this.submitSucceeded = true;
      this.organizationFormInfoModalRef.modalType.set(ModalTypes.Success);
      this.bootstrapService.manageModal("#addOrganizationModal", ModalActions.Hide);
    } else {
      this.organizationFormInfoModalRef.modalType.set(ModalTypes.Failure);
    }

    this.bootstrapService.manageModal("#organizationFormInfoModal", ModalActions.Show);
  }

  public confirmationModalCancelled(): void {
    this.bootstrapService.manageModal("#addOrganizationModal", ModalActions.Show);
    this.bootstrapService.manageModal("#organizationFormConfirmationModal", ModalActions.Hide);
    this.resolvePendingLeave(false);
  }
}